import "./page-ray-vision.scss";
import "../../js/core";
import "../../../assets/src/eos/js/video-youtube-iframe";
import Collapse from "bootstrap/js/src/collapse";

jQuery(function ($) {
  const modalEl = $("#modalResponseSent");

  function cleanBackdrops() {
    const backdrops = $(".modal-backdrop");
    if (backdrops.length > 1) {
      backdrops.not(":first").remove();
    }
  }

  $(document).on("hidden.bs.modal", ".modal", function () {
    if ($(".modal.show").length === 0) {
      $(".modal-backdrop").remove();
      $("body").removeClass("modal-open").css("padding-right", "");
    }
  });

  $(document).on("show.bs.modal", ".modal", cleanBackdrops);

  $(document).on("click", ".js-download-btn", function (e) {
    e.preventDefault();
    const $btn = $(this);
    const fileUrl = $btn.data("file-url");
    if (!fileUrl) return;

    const onclickCode = $btn.attr("onclick") || "";
    const eventLabelMatch = onclickCode.match(/'eventLabel':'([^']+)'/);
    const eventContextMatch = onclickCode.match(/'eventContext':'([^']+)'/);
    const eventPositionMatch = onclickCode.match(/'eventPosition':'([^']+)'/);

    const eventLabel = eventLabelMatch
      ? eventLabelMatch[1]
      : $btn.text().trim();
    const eventContext = eventContextMatch
      ? eventContextMatch[1]
      : $btn.text().trim();
    const eventPosition = eventPositionMatch
      ? eventPositionMatch[1]
      : "forest_solutions";

    fetch(fileUrl)
      .then((response) => {
        if (!response.ok) throw new Error("Download failed");
        return response.blob();
      })
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileUrl.split("/").pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        // === SUCCESS ===
        dataLayer.push({
          event: "EOSCOM",
          eventCategory: "EosComEvents",
          eventAction: "pdf_download_success",
          eventLabel: eventLabel,
          eventPosition: eventPosition,
          eventContext: eventContext,
          eventContent: "",
        });

        if (modalEl.length) {
          modalEl
            .find(".modal-title")
            .text(window.downloadModalTexts?.successTitle || "");
          modalEl
            .find(".message")
            .text(window.downloadModalTexts?.successMessage || "");
          modalEl.addClass("mail_sent");

          setTimeout(() => {
            cleanBackdrops();
            modalEl.modal("show");
          }, 3500);
        }
      })
      .catch(() => {
        // === ERROR ===
        dataLayer.push({
          event: "EOSCOM",
          eventCategory: "EosComEvents",
          eventAction: "pdf_download_error",
          eventLabel: eventLabel,
          eventPosition: eventPosition,
          eventContext: eventContext,
          eventContent: "",
        });

        if (modalEl.length) {
          modalEl
            .find(".modal-title")
            .text(window.downloadModalTexts?.errorTitle || "");
          modalEl
            .find(".message")
            .text(window.downloadModalTexts?.errorMessage || "");
          modalEl.removeClass("mail_sent");

          setTimeout(() => {
            cleanBackdrops();
            modalEl.modal("show");
          }, 4500);
        }
      });
  });
});

$(function () {
  import(
    /* webpackChunkName: "chunk.owl-carousel" */ "owl.carousel/src/js/owl.carousel"
  ).then(() => {
    import(
      /* webpackChunkName: "chunk.owl-carousel-navigation" */ "owl.carousel/src/js/owl.navigation"
    ).then(() => {
      import(
        /* webpackChunkName: "chunk.owl-carousel-autoplay" */ "owl.carousel/src/js/owl.autoplay"
      ).then(() => {
        $(".slider-mob-card-industries").owlCarousel({
          responsive: {
            0: {
              items: 1,
            },
            480: {
              items: 2,
            },
            768: {
              items: 3,
            },
            992: {
              items: 4,
            },
            1241: {
              items: 0,
              dots: false,
              nav: false,
              dotsEach: false,
              margin: 0,
            },
          },
          slideBy: 1,
          dots: false,
          nav: true,
          loop: false,
          margin: 20,
          smartSpeed: 200,
        });

        $(function () {
          $(window)
            .on("resize", function () {
              if ($(window).width() <= 1241) {
                $(".slider-mob-card-industries").addClass("owl-carousel");
              } else {
                $(".slider-mob-card-industries").removeClass("owl-carousel");
              }
            })
            .trigger("resize");
        });

        $(".owl-carousel").each(function (index) {
          $(this)
            .find(".owl-nav, .owl-dots")
            .wrapAll("<div class='owl-controls'></div>");
        });
      });
    });
  });
});

// STOP VIDEO and replay from the same place

function initModalYoutubePlayer() {
  let lastTime = 0;
  let timer = null;

  const modal = document.getElementById("modalVideoPopup");
  const videoWrap = modal?.querySelector(".video-wrap");

  if (!modal || !videoWrap) return;

  function extractId() {
    return videoWrap.dataset.videoId || null;
  }

  function createIframe(id) {
    const iframe = document.createElement("iframe");

    iframe.src =
      `https://www.youtube.com/embed/${id}?enablejsapi=1&autoplay=1&mute=1&rel=0`;

    iframe.allow = "autoplay; encrypted-media; fullscreen";
    iframe.setAttribute("allowfullscreen", "");
    iframe.classList.add("video-media");

    return iframe;
  }

  function send(iframe, func, args = []) {
    iframe.contentWindow?.postMessage(
      JSON.stringify({
        event: "command",
        func,
        args
      }),
      "*"
    );
  }

  modal.addEventListener("shown.bs.modal", function () {
    const id = extractId();
    if (!id) return;

    let iframe = videoWrap.querySelector("iframe");

    if (!iframe) {
      iframe = createIframe(id);
      videoWrap.innerHTML = "";
      videoWrap.appendChild(iframe);
    }

    setTimeout(() => {

      if (lastTime > 0) {
        send(iframe, "seekTo", [lastTime, true]);
      }

      send(iframe, "playVideo");

      setTimeout(() => {
        send(iframe, "setPlaybackQuality", ["hd1080"]);
      }, 400);

      setTimeout(() => {
        send(iframe, "setPlaybackQuality", ["hd1080"]);
      }, 1000);

      setTimeout(() => {
        send(iframe, "unMute");
        send(iframe, "setVolume", [100]);
      }, 300);

      setTimeout(() => {
        send(iframe, "unMute");
        send(iframe, "setVolume", [100]);
      }, 800);

      setTimeout(() => {
        send(iframe, "playVideo");
      }, 500);

      setTimeout(() => {
        send(iframe, "playVideo");
      }, 900);

      timer = setInterval(() => {
        send(iframe, "getCurrentTime");
      }, 600);

    }, 250);
  });

  modal.addEventListener("hidden.bs.modal", function () {
    const iframe = videoWrap.querySelector("iframe");
    if (!iframe) return;

    send(iframe, "getCurrentTime");

    setTimeout(() => {
      send(iframe, "pauseVideo");
    }, 100);

    clearInterval(timer);
  });

  window.addEventListener("message", function (event) {
    let data;

    try {
      data = JSON.parse(event.data);
    } catch {
      return;
    }

    if (data.event === "infoDelivery" && data.info?.currentTime) {
      lastTime = data.info.currentTime;
    }
  });
}

document.addEventListener("DOMContentLoaded", initModalYoutubePlayer);